import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';
import { s } from './TissStyles';
import { opLabels } from './TissConstants';
import { formatDateTime } from './TissHelpers';
import { useToast } from './TissShared';
import TransacaoDetalheModal from './TransacaoDetalheModal';
import { DocContent, AjudaContent } from './TabDocAjuda';

export default function TabDiagnostico({ dataInicio, dataFim }) {
  const [segment, setSegment] = useState('transacoes');

  return (
    <>
      {/* Segmented control */}
      <div style={s.segmented}>
        {[
          { id: 'transacoes', label: 'Transacoes SOAP' },
          { id: 'documentacao', label: 'Documentacao' },
        ].map(seg => (
          <button key={seg.id}
            style={{ ...s.segmentedBtn, ...(segment === seg.id ? s.segmentedBtnActive : {}) }}
            onClick={() => setSegment(seg.id)}>
            {seg.label}
          </button>
        ))}
      </div>

      {segment === 'transacoes' && <TransacoesSection dataInicio={dataInicio} dataFim={dataFim} />}
      {segment === 'documentacao' && <DocumentacaoSection />}
    </>
  );
}

// ==================== TRANSACOES SOAP ====================

function TransacoesSection({ dataInicio, dataFim }) {
  const [transacoes, setTransacoes] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ operacao: '', sucesso: '' });
  const [detail, setDetail] = useState(null);
  const toast = useToast();

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page, limit: 30, ...filters };
      if (dataInicio) params.dataInicio = dataInicio;
      if (dataFim) params.dataFim = dataFim;
      Object.keys(params).forEach(k => { if (params[k] === '') delete params[k]; });
      const res = await axios.get(`${API_URL}/tiss/transacoes`, { params });
      setTransacoes(res.data.data || []);
      setTotal(res.data.total || 0);
    } catch (err) { console.error('Erro transacoes:', err); }
    finally { setLoading(false); }
  }, [page, filters, dataInicio, dataFim]);

  useEffect(() => { load(); }, [load]);

  const verDetalhe = async (id) => {
    try {
      const res = await axios.get(`${API_URL}/tiss/transacoes/${id}`);
      setDetail(res.data);
    } catch (err) { toast.error('Erro ao buscar detalhe'); }
  };

  const opShortLabels = {
    teste_conexao: 'Teste Conexao',
    elegibilidade: 'Elegibilidade',
    solicitacao_procedimento: 'Solicitacao',
    worker_envio_guia: 'Envio Auto',
    reenvio_guia: 'Reenvio',
    status_guia: 'Status Guia',
    cancelamento_guia: 'Cancelamento',
    envio_lote: 'Envio Lote',
    reenvio_lote: 'Reenvio Lote',
    status_lote: 'Status Lote',
  };

  return (
    <>
      <div style={s.filtersRow}>
        <div style={s.filterGroup}>
          <label style={s.filterLabel}>Operacao</label>
          <select style={s.select} value={filters.operacao}
            onChange={e => { setFilters({ ...filters, operacao: e.target.value }); setPage(1); }}>
            <option value="">Todas</option>
            <option value="teste_conexao">Teste Conexao</option>
            <option value="elegibilidade">Elegibilidade</option>
            <option value="solicitacao_procedimento">Solicitacao</option>
            <option value="worker_envio_guia">Worker Envio</option>
            <option value="reenvio_guia">Reenvio</option>
            <option value="status_guia">Status Guia</option>
            <option value="cancelamento_guia">Cancelamento</option>
            <option value="envio_lote">Envio Lote</option>
            <option value="status_lote">Status Lote</option>
          </select>
        </div>
        <div style={s.filterGroup}>
          <label style={s.filterLabel}>Resultado</label>
          <select style={s.select} value={filters.sucesso}
            onChange={e => { setFilters({ ...filters, sucesso: e.target.value }); setPage(1); }}>
            <option value="">Todos</option>
            <option value="true">Sucesso</option>
            <option value="false">Erro</option>
          </select>
        </div>
      </div>

      <div style={s.card}>
        {loading ? <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>Carregando...</div> : transacoes.length === 0 ? (
          <div style={s.emptyState}>
            <div style={s.emptyIcon}>-</div>
            <p style={s.emptyText}>Nenhuma transacao registrada</p>
          </div>
        ) : (
          <>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>ID</th>
                  <th style={s.th}>Operacao</th>
                  <th style={s.th}>Data</th>
                  <th style={s.th}>Duracao</th>
                  <th style={s.th}>HTTP</th>
                  <th style={s.th}>Resultado</th>
                  <th style={s.th}></th>
                </tr>
              </thead>
              <tbody>
                {transacoes.map(t => (
                  <tr key={t.id} style={s.trHover}>
                    <td style={s.td}>#{t.id}</td>
                    <td style={s.td}><span style={{ fontSize: '12px' }}>{opShortLabels[t.operacao] || t.operacao}</span></td>
                    <td style={s.td}>{formatDateTime(t.inicio)}</td>
                    <td style={s.td}>{t.duracao_ms ? `${t.duracao_ms}ms` : '-'}</td>
                    <td style={s.td}>{t.http_status || '-'}</td>
                    <td style={s.td}>
                      <span style={{
                        ...s.badge,
                        backgroundColor: t.sucesso ? '#e8f5e9' : '#ffebee',
                        color: t.sucesso ? '#2e7d32' : '#c62828',
                      }}>{t.sucesso ? 'OK' : 'Erro'}</span>
                    </td>
                    <td style={s.td}>
                      <button style={s.btnSmall} onClick={() => verDetalhe(t.id)}>Ver</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', fontSize: '13px', color: '#666' }}>
              <span>{total} transacoes</span>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button style={s.btnSecondary} disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                <span style={{ padding: '6px 12px' }}>Pagina {page}</span>
                <button style={s.btnSecondary} disabled={transacoes.length < 30} onClick={() => setPage(p => p + 1)}>Proxima</button>
              </div>
            </div>
          </>
        )}
      </div>

      {detail && <TransacaoDetalheModal detail={detail} onClose={() => setDetail(null)} />}
    </>
  );
}

// ==================== DOCUMENTACAO (Doc + Ajuda merged) ====================

function DocumentacaoSection() {
  return (
    <>
      {/* Guia Pratico (old Ajuda) - expanded by default */}
      <details open style={{ marginBottom: '16px' }}>
        <summary style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '700', color: '#1976d2', padding: '12px 0', userSelect: 'none' }}>
          Guia Pratico (para recepcionistas)
        </summary>
        <AjudaContent />
      </details>

      {/* Documentacao Tecnica (old Doc) - collapsed by default */}
      <details style={{ marginBottom: '16px' }}>
        <summary style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '700', color: '#1976d2', padding: '12px 0', userSelect: 'none' }}>
          Documentacao Tecnica
        </summary>
        <DocContent />
      </details>
    </>
  );
}
